module.exports = __webpack_public_path__ + "img/as.cc92de63.jpg";